import { Link } from "react-router-dom";
import PageWrapper from "../components/shared/PageWrapper";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { ArrowIcon } from "../assets/icons";

type Props = {};

const FAQPage = (props: Props) => {

  useDocumentTitle("Chase the Ace FAQ | Multiplayer Card Game");

  return (
    <PageWrapper>
      <div className="item-list xl-gap">
        <div className="item-list">
          <Link to="/" className="icon-text secondary small">
            <ArrowIcon />
            Back to Home
          </Link>
          <h1 className="heading-large">Chase the Ace FAQ</h1>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small weight-boldy">Can you play Chase the Ace online?</p>
          <p className="body spaced">Yes, once a player creates a room they can invite anyone to join via the provided link and room code.</p>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small weight-bold">How many players do you need?</p>
          <p className="body spaced">A game requires at least 2 players, though it's best played with 4 or more. You can always add bots!</p>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small weight-bold">Is Chase the Ace the same as Screw Your Neighbour?</p>
          <p className="body spaced">Chase the Ace has gone by many names, popular in the USA as "Screw Your Neighbor" (though this is also the name used for other games). It has also been known as Ranter Go Round.</p>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small weight-bold">How long does a game take?</p>
          <p className="body spaced">Games typically take under 10 minutes, though with a lot of players and/or lives, a game can last a while.</p>
        </div>
        <div className="item-list large-gap">
          <p className="heading-small weight-bold">Is it free to play?</p>
          <p className="body spaced">Yup! Free to play and no downloads required.</p>
        </div>
      </div>
    </PageWrapper>
  )
};
export default FAQPage;